const panelOlaclickIsPwa = () => {
  const isPwa = ['fullscreen', 'standalone', 'minimal-ui']
    .some((displayMode) => window.matchMedia(`(display-mode: ${displayMode})`).matches)

  return isPwa
}

export default panelOlaclickIsPwa
